import cx from 'classnames';

const CustomParagraph = (props) => {
  return (
    <p
      {...props.attributes}
      className={cx('slate-text-block', props.attributes.className)}
    >
      {props.children}
    </p>
  );
};

export default CustomParagraph;
